import { useQuery } from "@tanstack/react-query";
import type { Stand } from "../models/Stand";
import { getActiveStands } from "../repositories/StandRepository";

// Module-level so React Query keeps the filtered array between renders.
const rollingStands = (rows: Stand[]) =>
	rows.filter((stand) => stand.StandType === "COMMON");
const rollingAndStraightenerStands = (rows: Stand[]) =>
	rows.filter(
		(stand) =>
			stand.StandType === "COMMON" || stand.StandType === "STRAIGHTENER",
	);

/**
 * The stands a user can pick: the seventeen rolling stands, plus the two
 * straightener stands on the pages whose legacy list had them (Rollsets,
 * Barrels, Pass IDs, Rolls in Use). The shear (S1) carries no rolls and is never offered; the legacy
 * catalog query dropped it too. Every variant shares one cached request.
 */
export const useStands = ({
	includeStraighteners = false,
}: {
	includeStraighteners?: boolean;
} = {}) =>
	useQuery<Stand[], Error>({
		queryKey: ["stands", "active"],
		queryFn: ({ signal }) => getActiveStands({ signal }),
		select: includeStraighteners ? rollingAndStraightenerStands : rollingStands,
		staleTime: 5 * 60 * 1000,
	});
